import * as Sentry from '@sentry/vue';

export default defineNuxtPlugin((nuxtApp) => {
  const router = useRouter();
  const config = useRuntimeConfig();
  const offlineMode = config.public.OFFLINE_MODE;

  const {
    public: { sentry },
  } = config;

  if (offlineMode == '1') {
    console.log(`Skip Sentry.io plugin integration for offline mode`);
    return;
  }

  if (!sentry.dsn) {
    return;
  }

  const tracePropagationTargets = (config.public.SENTRY_DOMAINS as any).split(',');

  if (!tracePropagationTargets) {
    return;
  }

  const sentryId = document.location.pathname === '/' ? 'sentry-feedback-home' : 'sentry-feedback';

  Sentry.init({
    app: nuxtApp.vueApp,
    dsn: sentry.dsn,
    environment: sentry.environment,
    integrations: [
      Sentry.feedbackIntegration({
        id: sentryId,
        showName: false,
        emailPlaceholder: 'your.email@your-company.com',
        isEmailRequired: false,
        emailLabel: 'Business Email',
        addScreenshotButtonLabel: 'Capture a screenshot',
        colorScheme: 'system',
        themeLight: {
          background: '#ffffff',
          accentBackground: '#6E12FF',
          foreground: '#000000',
          accentForeground: '#ffffff',
          outline: 0,
        },
        themeDark: {
          background: '#000000',
          accentBackground: '#6E12FF',
          foreground: '#ffffff',
          accentForeground: '#ffffff',
          outline: 0,
        },
        showBranding: false,
        triggerLabel: 'Any issue ?',
        formTitle: 'Any issue ?',
        messagePlaceholder: 'What’s the issue? How can we improve?',
        submitButtonLabel: 'Submit',
      }),
      Sentry.browserTracingIntegration({ router }),
      // Sentry.replayIntegration(),
      // For browser profiling to work we need to set special headers in our server response eg. for express: response.set("Document-Policy", "js-profiling");
      //Sentry.browserProfilingIntegration(),
    ],

    tracesSampleRate: 0.2, // Capture 100% of the transactions, change in prod

    // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
    tracePropagationTargets: tracePropagationTargets, // ["localhost", "https://app-dev.xeo.vision"],

    // Change in prod
    replaysSessionSampleRate: 0.2, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
    replaysOnErrorSampleRate: 0.2, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
    // Profiling
    profilesSampleRate: 0.2, // Profile 100% of the transactions. This value is relative to tracesSampleRate
  });

  Sentry.setTag('xeovision', config.public.XEOVISION_VERSION);
  Sentry.setTag('ifc2gltfcxconverter', config.public.IFC2GLTFCXCONVERTER_VERSION);
  // There is no more XEOKIT_SDK_VERSION and XEOKIT_CONVERT_VERSION in the runtime config
  // see use-versions.ts composable
  // Sentry.setTag('xeokit-sdk', config.public.XEOKIT_SDK_VERSION);
  // Sentry.setTag('xeokit-convert', config.public.XEOKIT_CONVERT_VERSION);
});
